// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "80efcae889ed2846a4ad" + ".chunk.js";
};